import ReefLogoMark from './ReefLogoMark';

// ==============================|| LOGO ICON ||============================== //

export default function LogoIcon() {
  return <ReefLogoMark size={35} />;
}
